<template>
    <div class="form-group legal-note">
        <div class="form-field">
            <div class="form-accordion" :class="{open: isAccordionOpen}">
                <div tabindex="0" @click="isAccordionOpen = !isAccordionOpen" class="legal-header" @keyup.enter.stop.prevent="isAccordionOpen = !isAccordionOpen" @keydown.space.prevent="isAccordionOpen = !isAccordionOpen">
                    <a v-html="$t('general:legal')"></a>
                    <div>
                        <SvgIcon :type="isAccordionOpen ? 'icon_arrow_up_black' : 'icon_arrow_down_red'" />
                    </div>
                </div>
                <div v-show="isAccordionOpen" class="legal-content">
                    <div class="text"> <slot></slot></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'

export default {
    name: 'LegalText',
    components: {
        SvgIcon
    },
    data() {
        return {
            isAccordionOpen: false
        }
    }
}
</script>
